import { PartialByKeys } from '@/types/types';
import { ComponentProps } from 'react';
import ReactPaginate from 'react-paginate';
import s from './Pagination.module.scss';
import {
  DotsIcon,
  LeftPaginationArrowActive,
  LeftPaginationArrowInactive,
  RightPaginationArrowActive,
  RightPaginationArrowInactive,
} from '@/assets';

type Props = PartialByKeys<
  ComponentProps<typeof ReactPaginate>,
  | 'pageRangeDisplayed'
  | 'renderOnZeroPageCount'
  | 'breakLabel'
  | 'nextLabel'
  | 'previousLabel'
> & { totalPages: number; currentPage: number };

export function Pagination({
  pageRangeDisplayed = 5,
  renderOnZeroPageCount = null,
  totalPages,
  currentPage,
  nextLabel,
  previousLabel,
  breakLabel,
  ...rest
}: Props) {
  const nextPageLabel =
    currentPage === totalPages - 1 ? (
      <img src={RightPaginationArrowInactive} alt="Previous page" />
    ) : (
      <img src={RightPaginationArrowActive} alt="Previous page" />
    );

  const previousPageLabel =
    currentPage === 0 ? (
      <img src={LeftPaginationArrowInactive} alt="Previous page" />
    ) : (
      <img src={LeftPaginationArrowActive} alt="Previous page" />
    );

  const breakLabelDefault = <img src={DotsIcon} alt="Break label" />;

  const displayNextLabel = nextLabel ? nextPageLabel : nextPageLabel;
  const displayPreviousLabel = previousLabel ? previousPageLabel : previousPageLabel;
  const displayBreakLabel = breakLabel ? breakLabelDefault : breakLabelDefault;

  return (
    <ReactPaginate
      pageRangeDisplayed={pageRangeDisplayed}
      renderOnZeroPageCount={renderOnZeroPageCount}
      nextLabel={displayNextLabel}
      previousLabel={displayPreviousLabel}
      breakLabel={displayBreakLabel}
      containerClassName={s.paginationContainer}
      pageLinkClassName={s.paginationTileLinkInactive}
      activeLinkClassName={s.paginationTileLinkActive}
      {...rest}
    />
  );
}
